module.exports = __webpack_public_path__ + "static/media/full-moon-face-svgrepo-com.78dbadd4.svg";